import {useContext} from "react";
import ClienteDirectoContext from "../../../context/ClienteDirectoContext";
import {ReactComponent as EmailIcon} from '../../../assets/icons/ic_email.svg';
import {ReactComponent as LocationIcon} from '../../../assets/icons/ic_location.svg';
import {ReactComponent as WhatsappIcon} from '../../../assets/icons/ic_whatsapp.svg';
import {FacebookIcon, InstagramIcon, LinkedinIcon, OtherIcon} from "../../../assets/socialMedia";
import banner from "../../../assets/images/banner-1.png";
import {ensureAbsoluteUrl, getSocialNetworkAriaLabel, getSocialNetworkKey, shouldExpandProducerDescription} from "../../../utils/producerHelpers";
import "./Producer.css";

const Producer = () => {
    const {datosPolkista, datosMaster, description, redesSociales, logo} = useContext(ClienteDirectoContext);

    const siteIcons = {
        facebook: FacebookIcon,
        instagram: InstagramIcon,
        linkedin: LinkedinIcon,
        other: OtherIcon,
    }
    const getIcon = (url) => siteIcons[getSocialNetworkKey(url)];

    const fullName = `${datosPolkista?.Nombre ?? ""} ${datosPolkista?.Apellido ?? ""}`.trim();
    const matricula = datosMaster?.matricula;

    return (
        <section className='producer'>
            <div className='producer__profile Landing__gradientMotion'>
                <p className='producer__eyebrow'>Tu Productor Asesor</p>
                <div className='producer__identity'>
                    {logo && (
                        <div className='producer__logo'>
                            <img src={logo} alt={fullName || "Logo productor"}/>
                        </div>
                    )}
                    <div className='producer__info'>
                        <h2>{fullName}</h2>
                        {matricula != null && matricula !== "" && (
                            <span className='producer__badge'>Mat. {matricula}</span>
                        )}
                    </div>
                </div>
            </div>

            <div
                className={`producer__description${shouldExpandProducerDescription(description) ? " producer__description--expanded" : ""}`}
                style={{backgroundImage: `url(${banner})`}}
            >
                <div className='producer__descriptionOverlay'/>
                {description?.length > 0 && (
                    <ul>
                        {description.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                )}
            </div>

            <div className='producer__contactCard'>
                <div className='contacto'>
                    {datosMaster?.telefono && (
                        <span>
                            <WhatsappIcon/>
                            <p>{datosMaster.telefono}</p>
                        </span>
                    )}
                    {datosMaster?.email && (
                        <span>
                            <EmailIcon/>
                            <p>{datosMaster.email}</p>
                        </span>
                    )}
                    {datosMaster?.direccion && (
                        <span className="ubicacion">
                            <LocationIcon/>
                            <p>{datosMaster.direccion}</p>
                        </span>
                    )}
                </div>
                {redesSociales?.length > 0 && (
                    <div className="socialmedia">
                        {redesSociales.map((url, index) => {
                            const Icon = getIcon(url);
                            const href = ensureAbsoluteUrl(url);

                            return (
                                <a
                                    key={index}
                                    href={href}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={getSocialNetworkAriaLabel(url)}
                                >
                                    <Icon/>
                                </a>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    )
};

export default Producer;
